import styles from './AccessBackOfficePermission.css'
import _ from 'lodash'
import Menu from './Menu'

class AccessBackOfficePermission extends React.Component {
  render () {
    let subMenuOf = _.groupBy(_.sortBy(this.props.permissions, 'priority_rank'), 'menu')
    let isManagerRole = this.props.roleDetail !== null && this.props.roleDetail.level === 2
    return (
      <div className={`row ${styles['container']}`}>
        <div className='col-lg-1' />
        <div className='col-lg-11'>
          <div className='row'>
            {
              Object.keys(subMenuOf).reduce((currentList, key) => {
                if (!isManagerRole && key.toUpperCase() === 'EMPLOYEES') {
                  return currentList
                } else {
                  currentList.push(
                    <Menu
                      menu={key}
                      fields={this.props.fields}
                      submenu={subMenuOf[key]}
                      isOwner={this.props.isOwner}
                      roleDetail={this.props.roleDetail}
                    />
                  )
                  return currentList
                }
              }, [])
            }
          </div>
        </div>
      </div>
    )
  }
}

export default AccessBackOfficePermission



// WEBPACK FOOTER //
// ./app/pages/Employees/Role/RoleDetail/RoleForm/AccessBackOfficePermission/AccessBackOfficePermission.js